import { UploadItem, UploadItemType } from "../types/upload-item";

const sortItems = (
  items: (UploadItem & { children?: UploadItem[] })[]
): void => {
  // Sort items: files first (alphabetically), then folders (alphabetically)
  items.sort((a, b) => {
    const aIsFolder = a.type === UploadItemType.FOLDER;
    const bIsFolder = b.type === UploadItemType.FOLDER;

    // Files come before folders
    if (aIsFolder && !bIsFolder) return 1;
    if (!aIsFolder && bIsFolder) return -1;

    // Within same type, sort alphabetically by name
    const aName = a.name.split("/").pop() || a.name;
    const bName = b.name.split("/").pop() || b.name;
    return aName.localeCompare(bName, undefined, { sensitivity: "base" });
  });

  // Recursively sort children
  items.forEach((item) => {
    if (item.children && item.children.length > 0) {
      sortItems(item.children);
    }
  });
};

export const buildHierarchy = (items: UploadItem[]): UploadItem[] => {
  const itemMap = new Map<string, UploadItem & { children?: UploadItem[] }>();
  const rootItems: UploadItem[] = [];

  items.forEach((item) => {
    itemMap.set(item.id, { ...item, children: [] });
  });

  items.forEach((item) => {
    const itemWithChildren = itemMap.get(item.id)!;

    const pathParts = item.name.split("/");

    if (pathParts.length > 1) {
      const parentPath = pathParts.slice(0, -1).join("/");

      const parentFolder = Array.from(itemMap.values()).find(
        (i) => i.type === UploadItemType.FOLDER && i.name === parentPath
      );

      if (parentFolder && parentFolder.children) {
        parentFolder.children.push(itemWithChildren);
      } else {
        rootItems.push(itemWithChildren);
      }
    } else {
      rootItems.push(itemWithChildren);
    }
  });

  // Sort all items: files first, then folders, both alphabetically
  sortItems(rootItems);

  return rootItems;
};
